/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { PaginatedResponseProductUploadHistoryItemDTOFromJSON, ProductUploadHistoryRequestDTOToJSON, } from '../models/index';
/**
 *
 */
export class ProductUpdateJobControllerApi extends runtime.BaseAPI {
    /**
     */
    async searchJobsRaw(requestParameters, initOverrides) {
        if (requestParameters['productUploadHistoryRequestDTO'] == null) {
            throw new runtime.RequiredError('productUploadHistoryRequestDTO', 'Required parameter "productUploadHistoryRequestDTO" was null or undefined when calling searchJobs().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/product-update-jobs/search`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductUploadHistoryRequestDTOToJSON(requestParameters['productUploadHistoryRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseProductUploadHistoryItemDTOFromJSON(jsonValue));
    }
    /**
     */
    async searchJobs(requestParameters, initOverrides) {
        const response = await this.searchJobsRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
